import { GridOptions, ColGroupDef, ColDef } from 'ag-grid-community'
import { TradingEntityMetaDetail } from 'api'
import { gridOptionsBase, TypedValueGetterParams, groupingRowColDef, StandardGridColumnId, withAllContext } from 'view/components/datagrid'
import { Translation, Locale } from 'locale'
import { TextInput } from 'view/components/inputs'
import { TradingEntityDefaultsHeaderRenderer } from './TradingEntityDefaultsHeaderRenderer'

export enum TradingEntityDefaultsGridColumnId {
  TRADING_ENTITY_DEFAULTS_MY_ENTITY = 'TRADING_ENTITY_DEFAULTS_MY_ENTITY',
  TRADING_ENTITY_DEFAULTS_COUNTERPARTY = 'TRADING_ENTITY_DEFAULTS_COUNTERPARTY',
  TRADING_ENTITY_DEFAULTS_ALIAS = 'TRADING_ENTITY_DEFAULTS_ALIAS'
}

export enum TradingEntityDefaultsUpdateFields {
  ALIAS = 'tradingEntityMeta.aliasTypeAndValues.[0].value'
}

export const tradingEntityDefaultsColumnDefs: (ColGroupDef | ColDef)[] = [
  {
    colId: StandardGridColumnId.CHECKBOX,
    headerName: Locale.translate(Translation.TC_EMPTY_HEADER),
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    width: 36,
    maxWidth: 36,
    pinned: 'left',
    lockPinned: true,
    lockPosition: true,
    lockVisible: true,
    enableRowGroup: false,
    filter: false,
    resizable: false,
    sortable: false
  },
  {
    ...groupingRowColDef,
    headerComponent: withAllContext(TradingEntityDefaultsHeaderRenderer),
    pinned: 'left',
    lockPinned: true,
    lockVisible: true
  },
  {
    colId: TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_MY_ENTITY,
    valueGetter: (params: TypedValueGetterParams<TradingEntityMetaDetail>) =>
      params.data?.ownerTradingEntity && `${params.data.ownerTradingEntity.publishedName} [${params.data.ownerTradingEntity.shortName}]`,
    headerName: Locale.translate(Translation.TC_MY_ENTITY),
    width: 200,
    filter: 'agSetColumnFilter',
    rowGroup: true,
    hide: true
  },
  {
    colId: TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_COUNTERPARTY,
    valueGetter: (params: TypedValueGetterParams<TradingEntityMetaDetail>) => params.data?.subjectTradingEntity?.publishedName,
    headerName: Locale.translate(Translation.TC_COUNTERPARTY),
    width: 200,
    filter: 'agSetColumnFilter'
  },
  {
    colId: TradingEntityDefaultsGridColumnId.TRADING_ENTITY_DEFAULTS_ALIAS,
    valueGetter: (params: TypedValueGetterParams<TradingEntityMetaDetail>) => params.data?.tradingEntityMeta.aliasTypeAndValues?.[0]?.value,
    headerName: Locale.translate(Translation.TC_ALIAS),
    width: 200,
    filter: 'agSetColumnFilter',
    cellEditorParams: {
      inputComponent: TextInput,
      updateField: TradingEntityDefaultsUpdateFields.ALIAS
    },
    editable: true
  }
]

export const tradingEntityDefaultsGridOptions: GridOptions<TradingEntityMetaDetail> = {
  ...gridOptionsBase,
  getRowId: ({ data: { tradingEntityMeta } }) => `${tradingEntityMeta.ownerTradingEntityId}-${tradingEntityMeta.subjectTradingEntityId}`
}
